import { render, staticRenderFns } from "./register.component.vue?vue&type=template&id=8d292cd0&scoped=true"
import script from "./register.component.vue?vue&type=script&lang=js"
export * from "./register.component.vue?vue&type=script&lang=js"
import style0 from "./register.component.vue?vue&type=style&index=0&id=8d292cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d292cd0",
  null
  
)

export default component.exports